import { render, staticRenderFns } from "./TraineeTranscript.vue?vue&type=template&id=5f499055&scoped=true"
import script from "./TraineeTranscript.vue?vue&type=script&lang=js"
export * from "./TraineeTranscript.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f499055",
  null
  
)

export default component.exports